import { Options, Vue } from 'vue-class-component';

import List from '@/pages/city/list/list.vue';

@Options({
  name: 'city',
  components: {
    'page-list': List,
  },
})
export default class CarGroup extends Vue {
  public isIndexOnly() {
    return /^[/]?city[/]?$/.test(this.$router.currentRoute.value.path);
  }
}
